const doc = [({"chartHeader":"Durchschnittlicher jährlicher Pro-Kopf-Konsum nach Land, reiner Alkohol, 2016", "labels":({"switzerland":"Schweiz", "yourConsumption":"Ihr Konsum"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;